import { render, staticRenderFns } from "./VisitorDetail.vue?vue&type=template&id=1798ef6e"
import script from "./VisitorDetail.vue?vue&type=script&lang=js"
export * from "./VisitorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports